import * as React from "react";
import Svg, { ClipPath, Defs, G, Path, Rect } from "react-native-svg";
const MarkChatReadIcon = ({ customColor, ...props }) => (
    <Svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <G clipPath="url(#clip0_7925_6088)">
            <Path d="M11.5587 13.334L9.1987 10.974L10.1387 10.034L11.552 11.4473L14.3787 8.62065L15.332 9.56065L11.5587 13.334ZM7.9987 11.334C7.9987 8.75398 10.0854 6.66732 12.6654 6.66732C13.3854 6.66732 14.0587 6.83398 14.6654 7.12065V2.66732C14.6654 1.93398 14.0654 1.33398 13.332 1.33398H2.66536C1.93203 1.33398 1.33203 1.93398 1.33203 2.66732V14.6673L3.9987 12.0007H7.9987C7.9987 11.8873 8.00536 11.7807 8.0187 11.6673C8.00536 11.5607 7.9987 11.4473 7.9987 11.334Z" fill={customColor ?? "black"} />
        </G>
        <Defs>
            <ClipPath id="clip0_7925_6088">
                <Rect width="16" height="16" fill="white" />
            </ClipPath>
        </Defs>
    </Svg>
);
export default MarkChatReadIcon;
